import { calculateInvoiceTotals } from "./invoiceCalc";

const calculateTotal = (invoiceData) => {
    let ESTR = 0, EOSP = 0;
    invoiceData.places.forEach(place => {
        place.goods.forEach(good => {
            ESTR += good.insurance * good.count;
            EOSP += good.price * good.count;
        });
    });

    const Nds = (invoiceData?.user_info?.contract_vat || 1) - 1;
    const r   = invoiceData?.user_info?.contract_type === 2 ? 0.05 : 0.03;

    // Ярусная логика страхования для contract_type === 3 (отдельное бизнес-правило)
    let Astr;
    const insurance_procent = invoiceData.user_info.insurance_procent;

    if (invoiceData.user_info.contract_type === 3 && insurance_procent === 0) {
        const total_price = ESTR;
        let rate;
        if (total_price <= 50000) {
            rate = Math.max(50, total_price * 0.008) / (total_price || 1);
        } else if (total_price <= 100000) {
            rate = 0.0075;
        } else if (total_price <= 150000) {
            rate = 0.007;
        } else if (total_price <= 300000) {
            rate = 0.006;
        } else if (total_price <= 500000) {
            rate = 0.0055;
        } else if (total_price <= 1000000) {
            rate = 0.005;
        } else {
            rate = 0.0045;
        }
        Astr = rate;
    } else {
        Astr = insurance_procent / 10000;
    }

    // Дополнительное страхование для тарифа «Сборный груз»
    let additional_astr = 0;
    if (invoiceData.tariff?.name?.includes("Сборный груз")) {
        const total_price = ESTR;
        if (total_price <= 50000) {
            additional_astr = Math.max(50, total_price * 0.003) / (total_price || 1);
        } else if (total_price <= 3000000) {
            additional_astr = 0.002;
        } else {
            additional_astr = 0.0018;
        }
    }
    Astr += additional_astr;

    // delivery_sum — NET тариф из API (без НДС)
    // additions_sum — GROSS доп. услуги (НДС уже добавлен на шаге 3)
    const YTAR_NET    = invoiceData.delivery_sum || 0;
    const XDOP_GROSS  = invoiceData.additions_sum || 0;
    const SSTR        = Astr * ESTR;
    const XDOP_NET    = Nds > 0 ? XDOP_GROSS / (1 + Nds) : XDOP_GROSS;
    const SSERV_NET   = YTAR_NET + XDOP_NET + SSTR;
    const SSERV_GROSS = SSERV_NET * (1 + Nds);

    const hand_sum_raw = invoiceData.hand_sum;
    const hand_sum = hand_sum_raw ? parseFloat(hand_sum_raw) : null;

    const result = calculateInvoiceTotals({
        SSERV_GROSS,
        EOSP,
        r,
        Nds,
        payGoods:                invoiceData.payment_on_receipt || false,
        payDelivery:             invoiceData.delivery_pay || false,
        recipientPaysCommission: invoiceData.commission || false,
        hand_sum,
    });

    return {
        delivery_pay_amount: result.AitogP_DISPLAY,
        contract_pay:        result.AitogO_DISPLAY,
        additional_sum:      invoiceData.payment_on_receipt ? result.ADOPSBOR_DISPLAY : 0,
    };
};

export default calculateTotal;
